import { Modal } from 'st-app';
import { requireRoleDashboardContext } from '../RoleDashboardContext';

export function QuickRefGuideModal() {
    const ctx = requireRoleDashboardContext();

    return <Modal show={[ctx.showQuickRefGuides, ctx.setShowQuickRefGuides]} title="Quick Reference Guides">
        This should be a tree control
    </Modal>;
}
